"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M28.052 19.146l5.548-5.311a13.98 13.98 0 0 0-22.966 5.989l-5.728-1.79a19.969 19.969 0 0 1 33.025-8.345L43.146 4.7a.5.5 0 0 1 .854.35V20H28.405a.5.5 0 0 1-.353-.854zM19.651 28a.5.5 0 0 1 .354.853l-5.626 5.294a13.982 13.982 0 0 0 22.987-5.971l5.728 1.79a19.974 19.974 0 0 1-33.084 8.292L4.854 43.11A.5.5 0 0 1 4 42.757V28z" })
);

